// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"Map_container-E077h","info":"Map_info-KiEh_","map":"Map_map-2Acl_"};